import React from 'react';
import Typography from '@material-ui/core/Typography';
import { styled } from '@material-ui/core/styles';
import { DSTheme } from '../../../styles/themes/types';

type AdminTileProps = {
  title: string;
  number: number;
  Icon: (props: React.SVGProps<SVGSVGElement>) => JSX.Element;
};

type AdminNavProps = {
  title: string;
  onClick: () => void;
};

const StyledAdminTile = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  borderRadius: '16px',
  padding: '32px',
  position: 'relative',
  height: '144px',

  '& p,h1': {
    color: theme.palette.primary.contrastText,
  },

  '& svg': {
    position: 'absolute',
    right: '32px',
    bottom: '32px',
  },
}));

const StyledAdminNavTile = styled('div')(({ theme }: { theme: DSTheme }) => ({
  backgroundColor: theme.palette.background.elevation1,
  borderRadius: '16px',
  padding: '32px',
  cursor: 'pointer',
}));

export const CrmOverviewTile: React.FC<AdminTileProps> = ({ title, number, Icon }) => (
  <StyledAdminTile>
    <Typography>{title}</Typography>
    <Typography variant="h1">{number}</Typography>
    <Icon stroke="#fff" width="88" height="88" />
  </StyledAdminTile>
);

export const AdminNavTile: React.FC<AdminNavProps> = ({ title, onClick }) => (
  <StyledAdminNavTile role="button" onClick={onClick}>
    <Typography variant="h2">{title}</Typography>
  </StyledAdminNavTile>
);
